"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MyService = void 0;
const service_1 = require("./service");
const maishu_toolkit_1 = require("maishu-toolkit");
// let clientFiles: string[];
let stationClientFiles = {};
class MyService extends service_1.Service {
    async files(stationPath) {
        stationPath = stationPath || "";
        if (stationClientFiles[stationPath]) {
            return stationClientFiles[stationPath];
        }
        stationClientFiles[stationPath] = await this.get(maishu_toolkit_1.pathConcat(stationPath, `clientFiles`))
            .catch(err => {
            console.error(err);
            return Promise.resolve([]);
        });
        return stationClientFiles[stationPath];
    }
    async config() {
        let r = await this.get("./websiteConfig");
        return r;
    }
}
exports.MyService = MyService;
